import { useEffect, useRef, useState } from "react";
import { Background } from "react-flow-renderer";
import {
  AddNoteButton,
  Container,
  FlowBoard,
  StatsButton,
  Wrapper,
} from "./styles";
import { edgeTypes, nodeTypes } from "./utils";
import { ConditionalModal } from "./ConditionalModal";
import { useLocation } from "react-router-dom";
import { useGantt } from "../../hooks/useGantt";
import { useSelector, useDispatch } from "react-redux";
import { fetchSingleActivedFlow } from "../../state/activedFlows/reducers";
import { toastAlert } from "../../components/Toastify/index";
import Loading from "../../components/LoadingTemplate/index";
import { useVerifyToken } from "../../hooks/useVerifyToken";
import {
  getElements,
  getMarkers,
  getOutScopedElements,
  getVisibleElements,
} from "../../state/activedFlows/selectors";
import { useHistory } from "react-router";
import { ProtectedComponent } from "../../components/general/Protected/index";
import { JobsBar } from "./JobsBar";
import { BellComponent } from "../../components/Notifications/BellComponent";
import { notificationNavigateDashboard } from "../../components/Notifications/BellComponent/utils";
import { activateOverlayForAdd } from "../../state/activedFlows/actions.js";
import { HiPencilAlt } from "react-icons/hi";
import { handleGetFlowRelatory } from "../../state/activedTasks/actions";
import { trackPromise } from "react-promise-tracker";
import FinishedFlowModal from "../../components/general/AlertModals/FinishedFlowModal/index";
import GanttModal from "./GanttModal/index";
import Overlay from "./Overlay/index.js";
import PDFModal from "../../components/general/PDFModal";
import PDFButton from "../../components/general/PDFButton";
import CustomConnectionLine from "../../components/CustomConnectionLine";
import TasksModal from "../../components/TasksModal";
import MenuBar from "./MenuBar";
import OptionsButton from "./OptionsButton";
import StatsIcon from "../../assets/icons/StatsIcon";
import Controls from "../../components/general/Controls";
import User from "../../components/general/UserAvatar";
import DropSelectWorkflow from "./DropSelectWorkflow/index.js";
import ActiveCritical from "../../components/general/ActiveCriticalButton/index.js";
import useActiveCriticalPath from "../../hooks/useActiveCriticalPatch";

const Workflow = () => {
  const [lock, setLock] = useState(false);
  const [openConditional, setOpenConditional] = useState(false);
  const [finishedModal, setFinishedModal] = useState(false);
  const [openPDF, setOpenPDF] = useState(false);
  const [relatory, setRelatory] = useState(null);
  const [title, setTitle] = useState("");
  const nodeId = useRef(null);

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const pane = useSelector((state) => state.activedFlows.pane);

  const [menuOptions, setMenuOptions] = useState({
    markers: true,
    outscoped: true,
  });
  const elements = useSelector((state) => getElements(state));
  const outscoped = useSelector((state) => getOutScopedElements(elements));
  const markers = useSelector((state) => getMarkers(elements));

  const visibleElements = useSelector((state) =>
    getVisibleElements(elements, menuOptions)
  );
  const user = useSelector((state) => state.auth.user);
  const history = useHistory();
  const dispatch = useDispatch();
  const status = pane.status;
  const activedFlow = pane.flow;
  const client = activedFlow.client;
  const flowStatus = pane.flow.status;
  const [openTask, setOpenTask] = useState({ isOpen: false, id: "" });
  const [openGantt, setOpenGantt] = useState(false);
  const [paneMoving, setPaneMoving] = useState(false);
  const [critical, setCritical] = useState(false);
  const [criticalStats, setCriticalStats] = useState(null);
  //Caso venha de redirecionador
  //const { notification: notificationFlowId, taskId } = location.state;

  useActiveCriticalPath(critical, visibleElements, setCriticalStats);

  const redirectionWorkflowFunctions = {
    task_mention: notificationNavigateDashboard,
  };

  const getRelatory = async () => {
    try {
      await trackPromise(
        dispatch(handleGetFlowRelatory({ flowId: activedFlow._id })).then(
          (res) => {
            setRelatory(res);
          }
        ),
        "pdf-data"
      );
    } catch (err) {
      console.log(err.message);
      toastAlert({ msg: err.message, isError: true });
    }
  };

  const fetchingData = async () => {
    if (user) {
      dispatch(
        fetchSingleActivedFlow({
          tenantId: !user.tenantId ? user?._id : user.tenantId,
          _id: params.get("flowId"),
        })
      ).then((res) => {
        if (res.error) {
          toastAlert({
            msg: `Ocorreu um ERRO ao carregar o Fluxo Ativo: ${res.payload.error} - CODE: ${res.payload.code}`,
            isError: true,
          });
        } else {
          setTitle(res.payload.flow.title);
        }
      });
    }
  };

  const verifyTaskPermissions = (node) => {
    const isJob = jobs.some((item) => item.id === node.id);

    if (!isJob) {
      return false;
    }

    return true;
  };

  const verifyConditionalPermissions = () => {
    if (user.rank === "colaborador") {
      toastAlert({
        msg: "ERRO: Somente Gerentes ou Administradores podem CONFIRMAR condicionais!",
        isError: true,
      });
      return false;
    }
    return true;
  };
  const handleNodeClick = (e, node) => {
    const type = node.type;
    const status = node.data.status;

    if (type === "task" && verifyTaskPermissions(node)) {
      setOpenTask({ id: node.id, isOpen: true });
      setCritical(false);
    } else if (
      type === "conditional" &&
      status === "doing" &&
      verifyConditionalPermissions()
    ) {
      nodeId.current = node.id;
      setOpenConditional(true);
    }
  };

  useVerifyToken();
  const {
    jobs,
    unMountedLoadGantt,
    status: ganttStatus,
    // clearGantt,
    // criticalPath,
  } = useGantt();

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      fetchingData();
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let isMounted = true;

    if (status === "succeeded" && isMounted) {
      unMountedLoadGantt(
        activedFlow.elements,
        activedFlow._id,
        activedFlow.flowStatus,
        activedFlow.createdAt
      );
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  useEffect(() => {
    let isMounted = true;

    if (flowStatus && flowStatus[0] === "finished" && isMounted) {
      setFinishedModal(true);
    } else {
      setFinishedModal(false);
    }
    return () => {
      isMounted = false;
    };
  }, [flowStatus]);

  const loadingStatus = status === "succeeded" && ganttStatus === "done";

  //* OverLay Block
  const reactFlowWrapper = useRef(null);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);

  const handleOpenOverlay = () => {
    const flowId = params.get("flowId");

    if (flowId) {
      dispatch(activateOverlayForAdd(flowId));
    } else {
      console.error("Flow ID is not available in the URL");
    }
  };

  return (
    <div>
      {loadingStatus ? (
        <Wrapper>
          <FlowBoard
            paneMoving={paneMoving}
            onMoveStart={() => setPaneMoving(true)}
            onMoveEnd={() => setPaneMoving(false)}
            onElementClick={!lock && handleNodeClick}
            nodesDraggable={false}
            elementsSelectable={false}
            minZoom={0}
            elements={visibleElements}
            nodeTypes={nodeTypes}
            edgeTypes={edgeTypes}
            deleteKeyCode="Delete"
            multiSelectionKeyCode="Control"
            connectionLineComponent={CustomConnectionLine}
            onDragOver={(event) => event.preventDefault()}
            ref={reactFlowWrapper}
            onLoad={setReactFlowInstance}
          >
            <Controls lock={lock} setUnlock={setLock} />

            <MenuBar
              client={client || "Carregando..."}
              flow={activedFlow}
              jobs={jobs}
              accountable={activedFlow.accountable}
              ganttStatus={ganttStatus}
            />

            <JobsBar
              jobs={jobs}
              user={user}
              modal={[openTask, setOpenTask]}
              options={[menuOptions, setMenuOptions]}
              visibility={{ markers, outscoped }}
            />

            <ConditionalModal
              isOpen={openConditional}
              onClose={() => setOpenConditional(false)}
              selector="#root"
              nodeId={nodeId}
            />
            <FinishedFlowModal
              isOpen={finishedModal}
              onClose={() => setFinishedModal(false)}
              onConfirm={() => history.push("/activedflows")}
              selector="#root"
              nodeId={nodeId}
            />
            <GanttModal
              isOpen={openGantt}
              onClose={() => setOpenGantt(false)}
            />
            <PDFModal
              name={activedFlow?.title}
              title={"Relatório Completo de Fluxo"}
              description={
                "Gere um relatório atualizado do Fluxo com todos os dados e estatísticas em PDF."
              }
              onConfirm={getRelatory}
              isOpen={openPDF}
              data={relatory}
              loading={false}
              onClose={() => setOpenPDF(false)}
            />
            {openTask.isOpen ? (
              <TasksModal
                flow={activedFlow}
                isOpen={openTask.isOpen}
                id={openTask.id}
                onClose={() => setOpenTask({ id: "", isOpen: false })}
              />
            ) : null}
            <Overlay
              reactFlowInstance={reactFlowInstance}
              reactFlowWrapper={reactFlowWrapper}
            />
            <Background />
            <DropSelectWorkflow
              project={activedFlow}
              title={title}
              setTitle={(data) => setTitle(data)}
              user={user}
            />
            <Container>
              <div style={{ marginRight: "1rem" }}>
                <PDFButton onClick={() => setOpenPDF(true)} />
              </div>
              <AddNoteButton onClick={handleOpenOverlay}>
                <HiPencilAlt />
                <span>Nota</span>
              </AddNoteButton>
              <ProtectedComponent
                allowed={["gerente", "admin"]}
                rank={user?.rank}
              >
                <OptionsButton />
              </ProtectedComponent>
              <StatsButton
                onClick={() =>
                  history.push({
                    pathname: "/AdvancedStats/",
                    state: "active",
                    search:
                      "?" +
                      new URLSearchParams({
                        flowId: params.get("flowId"),
                      }).toString(),
                  })
                }
              >
                <StatsIcon />
                <span>Estatísticas</span>
              </StatsButton>
              <ActiveCritical
                elements={visibleElements}
                critical={critical}
                setCritical={() => setCritical((prev) => !prev)}
                value={criticalStats ? criticalStats : null}
              />
              <div>
                <BellComponent
                  style={{ marginRight: "1rem" }}
                  redirectionFunctions={redirectionWorkflowFunctions}
                />
              </div>
              <User />
            </Container>
          </FlowBoard>
        </Wrapper>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default Workflow;
